import React from 'react'

import { MainLayout } from 'src/common/layouts/MainLayout/MainLayout'
import { StoryClientType } from 'src/strapi/types/storiesTypes'
import { AnalyticEventEnum } from 'src/utils/analytic/analyticEventEnum'
import { useAnalytic } from 'src/utils/analytic/useAnalytic'

import { StoryGetMatchedBlock } from './StoryGetMatchedBlock/StoryGetMatchedBlock'
import { StoryMainBlock } from './StoryMainBlock/StoryMainBlock'
import { StoryMeta } from './StoryMeta/StoryMeta'
import { StoryRecommendedBlock } from './StoryRecommendedBlock/StoryRecommendedBlock'

import s from './StoryPage.module.scss'

export type StoryPageProps = {
  story: StoryClientType
  recommendedStories: Array<StoryClientType>
}

export const StoryPage: React.FC<StoryPageProps> = ({
  story,
  recommendedStories,
}) => {
  const { analytic } = useAnalytic()
  analytic.event(AnalyticEventEnum.CASE_PAGE)

  return (
    <>
      <StoryMeta storyTitle={story.title || story.description} />

      <MainLayout classes={{ root: s.StoryPage }} pageAnalytic={'case'}>
        <StoryMainBlock story={story} />
        <StoryRecommendedBlock stories={recommendedStories} />
        <StoryGetMatchedBlock />
      </MainLayout>
    </>
  )
}
